import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "../customAxios.js";
import * as XLSX from "xlsx";
import * as EmailValidator from "email-validator";
import InputMask from "react-input-mask";
import {
  Autocomplete,
  Button,
  CircularProgress,
  FormControl,
  Grid,
  Paper,
  Chip,
  Stack,
  TextField,
} from "@mui/material";
import LoadingComponent from "./LoadingComponent";
import AlertBox from "./AlertBox";
import CustomDropzone from "./CustomDropzone";
import ProductList from "./ProductList";
import { regionsAndCommunes } from "../helpers/ChileanAddressesData";
import { orderTypeEnum, shippingMethodEnumChoices } from "../helpers/enums";
import { getImagesUrls } from "../utils/s3Utils.js";
import { useImagePreloader } from "../hooks/useImagePreLoader.jsx";
import { useAuth } from "../hooks/useAuth.jsx";

//GET URL PRESIGNED OF IMAGES
//dict with images key routes of the page
const imageskeyRoutes = {
  s3massiveUploadIcon: "assets/icons/massive-upload.png",
  s3manualUploadIcon: "assets/icons/manual-upload.png",
};

const imageUrls = await getImagesUrls(imageskeyRoutes, "uploadRequests");



function NewUploadRequests(props) {
  // Constants and basic helpers
  const { allImagesLoaded, timeoutReached } = useImagePreloader(
    imageUrls,
    3000
  );
  const { user } = useAuth();

  const isAdmin = user.user_type.includes("admin");
  const isSeller = user.user_type.includes("seller");
  const isOperator = user.user_type.includes("operator");
  const is_staff = user.is_staff;
  //  debugger;
  const isAdminSelfCheckout =
    user.admin_plan?.plan_type === "admin_checkout" ? true : false;

  let navigate = useNavigate();

  // States
  const [selectedFileType, setSelectedFileType] = useState("");

  // Admin
  const [sellerOptions, setSellerOptions] = useState(null);
  const [selectedSeller, setSelectedSeller] = useState(null);
  const [sellerWarehouseOptions, setSelectedSellerWarehouseOptions] =
    useState(null);
  const [selectedSellerWarehouse, setSelectedSellerWarehouse] = useState(null);
  // Seller
  const [warehouseOptions, setWarehouseOptions] = useState(null);
  const [selectedWarehouse, setSelectedWarehouse] = useState(null);

  // Drivers:
  const [driversOptions, setDriversOptions] = useState(null);
  const [selectedDriver, setSelectedDriver] = useState(null);

  // Country
  let originCountry = "";

  if (isAdmin)
    originCountry = user?.admin?.country_fk?.iso2 ?? "CL";
  if (isSeller)
    originCountry = user?.seller_company?.country_fk?.iso2 ?? "CL";

  console.log('user seller: ', user)
  console.log('originCountry: ', originCountry)

  const documentLabel = originCountry === "MX" ? "RFC" : "RUT*";
  const phoneMask = originCountry === "MX" ? "52 9 99 9999 9999" : "56 9 9999 9999";

  const DOCUMENT_ID_HEADER_BY_COUNTRY = {
    CL: "Rut",
    MX: "RFC",
  };

  // Excel required Headers

  const adminRequiredHeaders = [
    "Id_referencia",
    "Destinatario",
    "Direccion",
    "Comuna",
    "Region",
    "Metodo de envio",
    "Notas",
    DOCUMENT_ID_HEADER_BY_COUNTRY[originCountry] || "Rut",
    "Telefono",
    "Correo",
    "Bultos",
    "Tags",
  ];
  const sellerRequiredHeaders = [
    "Id_referencia",
    "Destinatario",
    "Direccion",
    "Comuna",
    "Region",
    "Metodo de envio",
    "Notas",
    DOCUMENT_ID_HEADER_BY_COUNTRY[originCountry] || "Rut",
    "Telefono",
    "Correo",
    "Bultos",
    "Tags",
  ];
  const operatorRequiredHeaders = [
    "Id_referencia",
    "Destinatario",
    "Direccion",
    "Comuna",
    "Region",
    "Metodo de envio",
    "Notas",
    DOCUMENT_ID_HEADER_BY_COUNTRY[originCountry] || "Rut",
    "Telefono",
    "Correo",
    "Bultos",
    "Tags",
  ];

  // Excel:
  const EXCEL_TEMPLATES = {
    CL: "https://ninja-hubs-public-prod.s3.us-east-1.amazonaws.com/templates/ninjahubs-template.xlsx",
    MX: "https://ninja-hubs-public-prod.s3.us-east-1.amazonaws.com/templates/ninjahubs-template-mx.xlsx",
  };

  const urlExcel = EXCEL_TEMPLATES[originCountry];

  const [files, setFiles] = useState([]);
  const [file, setFile] = useState(null);

  const [openFileErrorAlert, setOpenFileErrorAlert] = useState(false);
  const [validFile, setValidFile] = useState(false);
  const [submitPressed, setSubmitPressed] = useState(false);
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [messageAlert, setMessageAlert] = useState("");
  const [loading, setLoading] = useState(false);

  // Manual form
  const [referenceId, setReferenceId] = useState("");
  const [recipient, setRecipient] = useState("");
  const [recipientLastName, setRecipientLastName] = useState("");
  const [street, setStreet] = useState("");
  const [streetNumber, setStreetNumber] = useState("");
  const [selectedCommune, setSelectedCommune] = useState(null);
  const [communesOptions, setCommunesOptions] = useState([]);
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [selectedOrderType, setSelectedOrderType] = useState(null);
  const [notes, setNotes] = useState("");
  const [contactRut, setContactRut] = useState("");
  const [contactPhone, setContactPhone] = useState("");
  const [contactEmail, setContactEmail] = useState("");
  const [packages, setPackages] = useState("");
  const [weight, setWeight] = useState("");
  const [measures, setMeasures] = useState("");
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [selectedFromWarehouse, setselectedFromWarehouse] = useState(null);
  const [selectedToWarehouse, setselectedToWarehouse] = useState(null);
  const [communeWarehouses, setCommuneWarehouses] = useState([]);
  const [selectedShippingMethod, setSelectedShippingMethod] = useState(null);

  // MX Addresses:

  //MX
  const [mxCommune, setMxCommune] = useState("");
  const [mxSettlement, setMxSettlement] = useState("");
  const [mxPostalCode, setMxPostalCode] = useState("");
  const [mxState, setMxState] = useState("");

  // Products
  const [productOptions, setProductOptions] = useState([]);
  const [selectedProductList, setSelectedProductList] = useState([]);
  const [productSaved, setProductSaved] = useState(false);

  const [warehouseLoaded, setWarehouseLoaded] = useState(false);

  const orderTypeOptions = orderTypeEnum.map((orderType) => ({
    value: orderType.value,
    label: orderType.label,
  }));

  const regionsOptions = regionsAndCommunes.map((region) => ({
    value: region.value,
    label: region.label,
  }));

  useEffect(() => {
    if (isAdmin) {
      fetchUserSellers();
      if (isAdminSelfCheckout) fetchAdminDrivers();
    }
    if (isSeller) {
      fetchUserWarehouses();
    }
  }, [isAdmin, isSeller]);

  useEffect(() => {
    setFile(files[0]);
  }, [files]);

  useEffect(() => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "binary" });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json(worksheet, { defval: "" });

        //get the two return values of function validateExcel
        const [isValid, message] = validateExcel(json);
        setMessageAlert(message);

        if (isValid) {
          console.log("File is valid");
          setValidFile(true);
        } else {
          console.error("File is invalid");
          setOpenFileErrorAlert(true);
          setValidFile(false);
          setFiles([]);
        }
      };
      reader.readAsBinaryString(file);
    }
  }, [file]);

  useEffect(() => {
    if (selectedSeller) {
      fetchSellerWarehouses(selectedSeller.id);
    }
  }, [selectedSeller]);

  // Functions

  const uploadOrdersExcel = async () => {
    const selectedFile = file;
    setLoading(true);
    var formData = new FormData();
    formData.append("excel_file", selectedFile);
    if (isSeller && selectedWarehouse) {
      formData.append("warehouse_id", selectedWarehouse.id);
      formData.append("country", originCountry);
    }
    if (isAdmin && selectedSeller && selectedSellerWarehouse) {
      formData.append("seller_id", selectedSeller.id);
      formData.append("warehouse_id", selectedSellerWarehouse.id);
      formData.append("country", originCountry);
    }
    try {
      await axios.post("upload_excel_orders/", formData);
      setMessageAlert("Archivo cargado con éxito");
      setOpenSuccessAlert(true);
    } catch (error) {
      let errorMessage = "Error al cargar el archivo";
      if (
        error?.response &&
        error?.response?.data &&
        error?.response?.data?.error
      ) {
        errorMessage += ": " + error.response.data.error;
      }
      setMessageAlert(errorMessage);
      setOpenErrorAlert(true);
    } finally {
      setFiles([]);
      setFile(null);
      setSelectedWarehouse(null);
      setSelectedSeller(null);
      setSelectedSellerWarehouse(null);
      setLoading(false);
    }
  };

  const validateExcel = (data) => {
    const requiredHeaders = isAdmin
      ? adminRequiredHeaders
      : isSeller
        ? sellerRequiredHeaders
        : operatorRequiredHeaders;

    if (data.length === 0 || !data[0]) {
      return [false, "Archivo vacío, no se entregaron ordenes a cargar."];
    }

    if (isSeller && !selectedWarehouse) {
      return [false, "Debe seleccionar una bodega para cargar las órdenes"];
    }

    const headers = Object.keys(data[0]);
    const hasRequiredHeaders = requiredHeaders.every((header) =>
      headers.includes(header)
    );
    if (!hasRequiredHeaders) {
      console.log("Missing at least one required header");
      return [false, "Falta una columna requerida"];
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const rutRegex = /^\d{1,3}(?:\.\d{1,3}){2}-[\dkK]$/; // Basic RUT validation pattern

    for (const row of data) {
      // Validate Rut if it exists
      if (row["Rut"] && !rutRegex.test(row["Rut"])) {
        console.log("formato de rut inválido");

        return [
          false,
          `formato de rut inválido en fila ${data.indexOf(row) + 2}`,
        ];
      }
      // Vaalidate if Id_referencia exists
      if (!row["Id_referencia"]) {
        console.log("Id_referencia inválido");
        return [
          false,
          `Id_referencia inválido en fila ${data.indexOf(row) + 2}`,
        ];
      }

      // Validate Destinatario exists
      if (!row["Destinatario"].trim()) {
        console.log("Attributo Destinatario inválido");
        return [
          false,
          `Attributo Destinatario inválido en fila ${data.indexOf(row) + 2}`,
        ];
      }

      // Validate Email if it exists
      if (row["Correo"] && !emailRegex.test(row["Correo"])) {
        console.log("Formato de correo inválido");
        return [
          false,
          `Formato de correo inválido en fila ${data.indexOf(row) + 2}`,
        ];
      }

      // Validate Direction exists
      if (!row["Direccion"].trim()) {
        console.log("Attributo Direccion inválido");
        return [
          false,
          `Attributo Direccion inválido en fila ${data.indexOf(row) + 2}`,
        ];
      }

      //validate existance of comuna
      if (!row["Comuna"].trim()) {
        console.log("Attributo Comuna inválido");
        return [
          false,
          `Attributo Comuna inválido en fila ${data.indexOf(row) + 2}`,
        ];
      }

      //validate existance of region
      if (!row["Region"].trim()) {
        console.log("Attributo Region inválido");
        return [
          false,
          `Attributo Region inválido en fila ${data.indexOf(row) + 2}`,
        ];
      }

      //validate existance of shipping method
      if (!row["Metodo de envio"].trim()) {
        console.log("Attributo Metodo de Envio inválido");
        return [
          false,
          `Attributo Metodo de Envio inválido en fila ${data.indexOf(row) + 2}`,
        ];
      }

      // Validate Bultos as a positive integer
      if (!(Number.isInteger(row["Bultos"]) && row["Bultos"] > 0)) {
        console.log("Attributo Bultos inválido");
        return [
          false,
          `Attributo Bultos inválido en fila ${data.indexOf(row) + 2}`,
        ];
      }
    }
    return [true, "File is valid"];
  };

  async function fetchUserSellers() {
    try {
      const {
        data: { serialized_sellers },
      } = await axios.get("admins/sellers-list/");
      setSellerOptions(serialized_sellers);
    } catch (error) {
      console.error(`Error al cargar los sellers: ${error}`);
    }
  }

  async function fetchSellerWarehouses(seller_id) {
    if (seller_id === undefined) {
      return;
    }

    try {
      const { data } = await axios.get(
        `admins/seller_warehouses/${seller_id}/`
      );
      setSelectedSellerWarehouseOptions(data);
    } catch (error) {
      console.error(`Error al cargar la relacion seller_warehouse: ${error}`);
    }
  }

  async function fetchUserWarehouses() {
    try {
      const { data } = await axios.get("sellers/warehouses/");
      setWarehouseOptions(data);
    } catch (error) {
      console.error(`Error al cargar las bodegas: ${error}`);
    }
  }

  const fetchProductsOptions = async (company_id, order_type) => {
    try {
      const { data } = await axios.get(
        `products/company_products/${company_id}/${order_type}/`
      );
      if (
        order_type === "delivery_fulfillment" ||
        order_type === "pick_up_fulfillment"
      ) {
        const filteredProducts = data.filter(
          (product) => product.ideal_stock > 0
        );
        setProductOptions(filteredProducts);
      } else {
        setProductOptions(data);
      }
    } catch (error) {
      console.error(`Error al cargar los productos de la compañia: ${error}`);
    }
  };

  async function fetchAdminDrivers() {
    try {
      const { data } = await axios.get("admins/my-drivers/");
      setDriversOptions(data);
    } catch (error) {
      console.error(`Error al cargar los repartidores: ${error}`);
    }
  }

  // Handlers

  const handleSelectedSellerChange = (newValue) => {
    setSelectedSeller(newValue);
    fetchSellerWarehouses();
  };

  async function handleFileSubmit() {
    uploadOrdersExcel();
  }

  const handleDelete = (path) => {
    setFiles(files.filter((file) => file.path !== path));
  };

  const handleFileDrop = (acceptedFiles) => {
    // Handle files here
    console.log("Archivos subidos:", acceptedFiles);
    acceptedFiles.forEach((file) => {
      setFiles((prevFiles) => {
        return [...prevFiles, file];
      });
    });
  };

  const clearData = () => {
    setFiles([]);
    setReferenceId("");
    setRecipient("");
    setStreet("");
    setStreetNumber("");
    setSelectedCommune(null);
    setSelectedRegion(null);
    setNotes("");
    setContactRut("");
    setContactPhone("");
    setContactEmail("");
    setPackages("");
    setWeight("");
    setMeasures("");
    setSelectedCompany(null);
    setSelectedShippingMethod(null);
    setselectedFromWarehouse(null);
    setSubmitPressed(false);
    setSelectedProductList([]);
    setProductOptions([]);
    setProductSaved(false);
    setWarehouseLoaded(false);
    setCommuneWarehouses([]);
    setselectedToWarehouse(null);
    setMxSettlement("");
    setMxPostalCode("");
    setMxCommune("");
  };

  const handleSelectCompany = (event, newValue) => {
    event.preventDefault();
    setSelectedCompany(newValue);
    setSelectedProductList([]);
    setProductOptions([]);
    if (newValue !== null && selectedOrderType && selectedOrderType.value) {
      fetchProductsOptions(newValue.id, selectedOrderType.value);
    }
  };

  const handleSelectOrderType = (event, newValue) => {
    event.preventDefault();
    setSelectedOrderType(newValue);
    setSelectedShippingMethod(null);
    setselectedFromWarehouse(null);
    setselectedToWarehouse(null);
    setCommuneWarehouses([]);
    setSelectedCommune(null);
    setSelectedRegion(null);
    setProductSaved(false);
    setWarehouseLoaded(false);
    setSelectedProductList([]);
    if (newValue !== null && selectedCompany !== null) {
      fetchProductsOptions(selectedCompany.id, newValue.value);
    }

    // const selectedOrderTypeData = orderTypeEnum.find(orderType => orderType.value === ( newValue ? newValue.value: ""));
  };

  const handleSelectRegion = (event, newValue) => {
    event.preventDefault();
    setSelectedRegion(newValue);
    setSelectedCommune(null);
    const selectedRegionData = regionsAndCommunes.find(
      (region) => region.value === (newValue ? newValue.value : "")
    );
    const newCommunesOptions = selectedRegionData
      ? selectedRegionData.communes.map((commune) => ({
        value: commune.value,
        label: commune.label,
      }))
      : [];
    setCommunesOptions(newCommunesOptions);
  };

  async function handleSubmit() {
    setSubmitPressed(true);

    // Set country Address:

    const ADDRESS_BUILDERS = {
      'CL': () => ({
        country: "CL",
        region: selectedRegion?.value || "",
        commune: selectedCommune?.value || "",
        street: street,
        street_number: streetNumber,
      }),
      'MX': () => ({
        country: "MX",
        street: street,
        street_number: streetNumber,
        commune: mxCommune,
        settlement: mxSettlement,
        postal_code: mxPostalCode,
        region: mxState,
      }),
    };

    const shippingAddress = ADDRESS_BUILDERS[originCountry]();

    if (
      selectedFileType === "Carga manual" &&
      referenceId !== "" &&
      recipient !== "" &&
      contactPhone !== "" &&
      contactEmail !== "" &&
      contactRut !== "") {
      setLoading(true);

      try {
        const { data } = await axios.post("create_single_order/", {
          seller_id: isAdmin ? selectedSeller.id : null,
          warehouse_id: isAdmin
            ? selectedSellerWarehouse.id
            : selectedWarehouse.id,
          reference_id: referenceId,
          recipient: {
            name: recipient,
            last_name: recipientLastName,
            phone: contactPhone,
            email: contactEmail,
            rut: contactRut,
          },
          shipping_address: shippingAddress,
          delivery_shipping_method: selectedShippingMethod.value,
          packages: packages,
          notes: notes,
          weight: weight,
        });
        console.log(data);
        setLoading(false);
        setMessageAlert("Orden creada con éxito");
        setOpenSuccessAlert(true);
        clearData();
        navigate("/home/upload-success-order");
      } catch (error) {
        console.error(`Error al crear la orden: ${error}`);
        setLoading(false);
        setMessageAlert("Error al crear la orden");
        setOpenErrorAlert(true);
      }
    } else {
      setMessageAlert("Faltan campos obligatorios");
      setOpenErrorAlert(true);
    }
  }

  return (
    <>
      {!allImagesLoaded &&
        !timeoutReached &&
        (sellerOptions || warehouseOptions) ? (
        <LoadingComponent />
      ) : (
        <>
          <Grid item xs={12}>
            <h1>Carga de Ordenes</h1>
          </Grid>
          <Grid item xs={12}>
            <FormControl>
              <Link to="/home" className="back-login-btn">
                <i className="material-icons-outlined forgotten-back-arrow">
                  arrow_back
                </i>
                <p>Volver atrás</p>
              </Link>
            </FormControl>
          </Grid>
          <Grid
            container
            className="select-ecommerce-container"
            style={{ marginBottom: "5px" }}
          >
            <Grid item xs={12} sm={12} className="flex-center">
              <h5>Tipo de carga</h5>
            </Grid>
            <Grid sx={{ flexGrow: 1 }} container>
              <Grid item xs={12}>
                <Grid container justifyContent="center">
                  <Grid item className="option first-row">
                    <Paper
                      elevation={0}
                      className={`select-option ${selectedFileType === "Carga masiva" ? "selected" : ""
                        }`}
                      onClick={() => {
                        setSelectedFileType("Carga masiva");
                      }}
                    >
                      <img
                        src={imageUrls.s3massiveUploadIcon}
                        alt="carga masiva"
                      />
                      <p>Carga masiva</p>
                    </Paper>
                  </Grid>
                  {(isAdmin || isSeller) && (
                    <Grid item className="option second-row">
                      <Paper
                        elevation={0}
                        className={`select-option ${selectedFileType === "Carga manual" ? "selected" : ""
                          }`}
                        onClick={() => {
                          clearData();
                          setSelectedFileType("Carga manual");
                        }}
                      >
                        <img
                          src={imageUrls.s3manualUploadIcon}
                          alt="carga manual"
                        />
                        <p>Carga manual</p>
                      </Paper>
                    </Grid>
                  )}
                </Grid>
              </Grid>
              {selectedFileType === "Carga masiva" && (
                <Grid container className="container-upload-files">
                  <Grid item xs={12} className="flex-center">
                    <h5>
                      Carga tu orden mediante{" "}
                      <span className="fw-medium">{selectedFileType}</span>
                    </h5>
                  </Grid>
                  <Grid item xs={12} className="flex-center download-container">
                    <p>{"Si no tienes a mano el archivo, puedes "}</p>
                    <a
                      href={urlExcel}
                      target="_blank"
                      rel="noopener noreferrer"
                      download
                    >
                      <p>{" descargar la plantilla "}</p>
                    </a>
                  </Grid>
                  {isAdmin && (
                    <Grid item xs={12} className="flex-center">
                      <Autocomplete
                        fullWidth
                        id="seller-select"
                        options={sellerOptions}
                        getOptionLabel={(seller) => {
                          return seller.company.social_reason;
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Seller"
                            helperText={
                              submitPressed &&
                              selectedSeller === null &&
                              "Campo obligatorio"
                            }
                            error={submitPressed && selectedSeller === null}
                          />
                        )}
                        value={selectedSeller}
                        onChange={(event, newValue) =>
                          handleSelectedSellerChange(newValue)
                        }
                      />
                    </Grid>
                  )}
                  {isAdmin && selectedSeller && (
                    <Grid item xs={12} className="flex-center">
                      <Autocomplete
                        fullWidth
                        id="seller-warehouse-select"
                        options={
                          sellerWarehouseOptions ? sellerWarehouseOptions : []
                        }
                        getOptionLabel={(warehouse) => {
                          return warehouse.name;
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Warehouse"
                            helperText={
                              submitPressed &&
                              selectedSellerWarehouse === null &&
                              "Campo obligatorio"
                            }
                            error={
                              submitPressed && selectedSellerWarehouse === null
                            }
                          />
                        )}
                        value={selectedSellerWarehouse}
                        onChange={(event, newValue) =>
                          setSelectedSellerWarehouse(newValue)
                        }
                      />
                    </Grid>
                  )}
                  {isSeller && (
                    <Grid item xs={12} className="flex-center">
                      <Autocomplete
                        fullWidth
                        id="warehouse-select"
                        options={warehouseOptions}
                        getOptionLabel={(warehouse) => {
                          return warehouse.name;
                        }}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label="Warehouse"
                            helperText={
                              submitPressed &&
                              selectedWarehouse === "" &&
                              "Campo obligatorio"
                            }
                            error={submitPressed && selectedWarehouse === ""}
                          />
                        )}
                        value={selectedWarehouse}
                        onChange={(event, newValue) =>
                          setSelectedWarehouse(newValue)
                        }
                      />
                    </Grid>
                  )}
                </Grid>
              )}
              {selectedFileType === "Carga manual" && (
                <>
                  <Grid container className="container-upload-files">
                    <Grid container style={{ marginTop: "20px" }}>
                      <Grid item xs={12} className="flex-center">
                        <h5>
                          Carga tu orden mediante{" "}
                          <span className="fw-medium">{selectedFileType}</span>
                        </h5>
                      </Grid>
                      <Grid item xs={12} className="flex-center">
                        <Grid container className="manual-upload-container">
                          <Grid item xs={12} sm={6} className="pd-r-10">
                            <Autocomplete
                              fullWidth
                              id="shipping-select"
                              options={shippingMethodEnumChoices}
                              getOptionLabel={(shippingMethod) =>
                                shippingMethod ? shippingMethod.label : ""
                              }
                              isOptionEqualToValue={(option, value) =>
                                option.value === value?.value
                              } // Compare by 'value'
                              renderInput={(params) => (
                                <TextField
                                  {...params}
                                  label="Tipo de Envío"
                                  helperText={
                                    submitPressed &&
                                    selectedShippingMethod === null &&
                                    "Campo obligatorio"
                                  }
                                  error={
                                    submitPressed &&
                                    selectedShippingMethod === null
                                  }
                                />
                              )}
                              value={selectedShippingMethod}
                              onChange={(event, newValue) =>
                                setSelectedShippingMethod(newValue)
                              }
                            />
                          </Grid>
                          {isAdmin && (
                            <Grid item xs={12} className="flex-center">
                              <Autocomplete
                                fullWidth
                                id="seller-select"
                                options={sellerOptions}
                                getOptionLabel={(seller) => {
                                  return seller.company.social_reason;
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Seller"
                                    helperText={
                                      submitPressed &&
                                      selectedSeller === null &&
                                      "Campo obligatorio"
                                    }
                                    error={
                                      submitPressed && selectedSeller === null
                                    }
                                  />
                                )}
                                value={selectedSeller}
                                onChange={(event, newValue) =>
                                  handleSelectedSellerChange(newValue)
                                }
                              />
                            </Grid>
                          )}
                          {isAdmin && selectedSeller && (
                            <Grid item xs={12} className="flex-center">
                              <Autocomplete
                                fullWidth
                                id="seller-warehouse-select"
                                options={
                                  sellerWarehouseOptions
                                    ? sellerWarehouseOptions
                                    : []
                                }
                                getOptionLabel={(warehouse) => {
                                  return warehouse.name;
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Warehouse"
                                    helperText={
                                      submitPressed &&
                                      selectedSellerWarehouse === null &&
                                      "Campo obligatorio"
                                    }
                                    error={
                                      submitPressed &&
                                      selectedSellerWarehouse === null
                                    }
                                  />
                                )}
                                value={selectedSellerWarehouse}
                                onChange={(event, newValue) =>
                                  setSelectedSellerWarehouse(newValue)
                                }
                              />
                            </Grid>
                          )}

                          {isSeller && (
                            <Grid item xs={12} sm={6} className="pd-l-10">
                              <Autocomplete
                                fullWidth
                                id="warehouse-select"
                                options={warehouseOptions}
                                getOptionLabel={(warehouse) => {
                                  return warehouse.name;
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Warehouse"
                                    helperText={
                                      submitPressed &&
                                      selectedWarehouse === "" &&
                                      "Campo obligatorio"
                                    }
                                    error={
                                      submitPressed && selectedWarehouse === ""
                                    }
                                  />
                                )}
                                value={selectedWarehouse}
                                onChange={(event, newValue) =>
                                  setSelectedWarehouse(newValue)
                                }
                              />
                            </Grid>
                          )}
                          <Grid item xs={12} sm={6} className="pd-r-10">
                            <TextField
                              fullWidth
                              variant="outlined"
                              label="Id Referencia*"
                              name="reference_id"
                              value={referenceId}
                              error={submitPressed && referenceId === ""}
                              helperText={
                                submitPressed && referenceId === ""
                                  ? "Campo obligatorio"
                                  : ""
                              }
                              onChange={(e) => setReferenceId(e.target.value)}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} className="pd-l-10">
                            <TextField
                              fullWidth
                              error={submitPressed && recipient === ""}
                              variant="outlined"
                              label="Nombre Destinatario*"
                              name="recipient"
                              value={recipient}
                              onChange={(e) => setRecipient(e.target.value)}
                              helperText={
                                submitPressed && recipient === ""
                                  ? "Campo obligatorio"
                                  : ""
                              }
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} className="pd-r-10">
                            <TextField
                              fullWidth
                              error={submitPressed && recipientLastName === ""}
                              variant="outlined"
                              label="Apellido Destinatario*"
                              name="recipient"
                              value={recipientLastName}
                              onChange={(e) =>
                                setRecipientLastName(e.target.value)
                              }
                              helperText={
                                submitPressed && recipientLastName === ""
                                  ? "Campo obligatorio"
                                  : ""
                              }
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} className="pd-l-10">
                            <TextField
                              fullWidth
                              error={submitPressed && street === ""}
                              variant="outlined"
                              label="Calle*"
                              name="street"
                              value={street}
                              onChange={(e) => setStreet(e.target.value)}
                              helperText={
                                submitPressed && street === ""
                                  ? "Campo obligatorio"
                                  : ""
                              }
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} className="pd-r-10">
                            <TextField
                              fullWidth
                              error={submitPressed && streetNumber === ""}
                              variant="outlined"
                              label="Número*"
                              name="street_number"
                              value={streetNumber}
                              onChange={(e) => setStreetNumber(e.target.value)}
                              helperText={
                                submitPressed && streetNumber === ""
                                  ? "Campo obligatorio"
                                  : ""
                              }
                            />
                          </Grid>

                          {originCountry == "CL" ? (
                            <>
                              <Autocomplete
                                fullWidth
                                id="region-select"
                                options={regionsOptions}
                                getOptionLabel={(region) => (region ? region.label : "")}
                                isOptionEqualToValue={(option, value) =>
                                  option.value === value?.value
                                } // Compare by 'value'
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Región"
                                    helperText={
                                      submitPressed &&
                                      selectedRegion === null &&
                                      "Campo obligatorio"
                                    }
                                    error={submitPressed && selectedRegion === null}
                                  />
                                )}
                                value={selectedRegion}
                                onChange={(event, newValue) =>
                                  handleSelectRegion(event, newValue)
                                }
                              />
                              <Autocomplete
                                fullWidth
                                id="communes-select"
                                options={communesOptions}
                                getOptionLabel={(commune) => (commune ? commune.label : "")}
                                isOptionEqualToValue={(option, value) =>
                                  option.value === value?.value
                                } // Compare by 'value'
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    label="Comuna"
                                    helperText={
                                      submitPressed &&
                                      selectedCommune === null &&
                                      "Campo obligatorio"
                                    }
                                    error={submitPressed && selectedCommune === null}
                                  />
                                )}
                                value={selectedCommune}
                                onChange={(event, newValue) => setSelectedCommune(newValue)}
                              />
                            </>
                          ) : null}
                          {originCountry == "MX" ? (
                            <>
                              <Grid item xs={12} sm={6} className="pd-l-10">
                              <TextField
                                fullWidth
                                variant="outlined"
                                label="Comuna"
                                name="mxCommune"
                                value={mxCommune}
                                onChange={(e) => setMxCommune(e.target.value)}
                               helperText={
                                      submitPressed &&
                                      mxCommune === "" &&
                                      "Campo obligatorio"
                                    }
                                error={submitPressed && mxCommune === ""}
                              />
                              </Grid>
                              <Grid item xs={12} sm={6} className="pd-l-10">
                              <TextField
                                fullWidth

                                variant="outlined"
                                label="Colonia"
                                name="mxSettlement"
                                value={mxSettlement}
                                onChange={(e) => setMxSettlement(e.target.value)}
                                helperText={
                                      submitPressed &&
                                      mxSettlement === "" &&
                                      "Campo obligatorio"
                                    }
                                error={submitPressed && mxSettlement === ""}
                              />
                              </Grid>
                              <Grid item xs={12} sm={6} className="pd-l-10">
                              <TextField
                                fullWidth
                                variant="outlined"
                                label="Estado"
                                name="mxState"
                                value={mxState}
                                onChange={(e) => setMxState(e.target.value)}
                                helperText={
                                      submitPressed &&
                                      mxState === "" &&
                                      "Campo obligatorio"
                                    }
                                error={submitPressed && mxState === ""}
                              />
                              </Grid>
                              <Grid item xs={12} sm={6} className="pd-l-10">
                              <TextField
                                fullWidth
                                variant="outlined"
                                label="Código Postal"
                                name="postal_code"
                                value={mxPostalCode}
                                onChange={(e) => setMxPostalCode(e.target.value)}
                                helperText={
                                      submitPressed &&
                                      mxPostalCode === "" &&
                                      "Campo obligatorio"
                                    }
                                error={submitPressed && mxPostalCode === ""}
                              />
                              </Grid>

                            </>
                          ) : null}
                          <Grid item xs={12} sm={6} className="pd-l-10">
                            <TextField
                              fullWidth
                              variant="outlined"
                              label="Notas"
                              name="notes"
                              value={notes}
                              onChange={(e) => setNotes(e.target.value)}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} className="pd-r-10">
                            <TextField
                              fullWidth
                              type="number"
                              variant="outlined"
                              label="Peso (en gramos)*"
                              name="weight"
                              value={weight}
                              inputProps={{ min: 1 }}
                              error={
                                submitPressed &&
                                (weight === "" || isNaN(weight))
                              }
                              helperText={
                                submitPressed &&
                                  (weight === "" || isNaN(weight))
                                  ? "Campo obligatorio y debe ser numérico"
                                  : ""
                              }
                              onChange={(e) => {
                                const value = e.target.value;
                                // Optional: Prevent non-numeric input from being stored
                                if (!isNaN(value) || value === "") {
                                  setWeight(value);
                                }
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} className="pd-l-10">
                            <TextField
                              fullWidth
                              type="number"
                              variant="outlined"
                              label="Bultos *"
                              name="packages"
                              value={packages}
                              inputProps={{ min: 1 }}
                              error={
                                submitPressed &&
                                (packages === "" || isNaN(packages))
                              }
                              helperText={
                                submitPressed &&
                                  (packages === "" || isNaN(packages))
                                  ? "Campo obligatorio y debe ser numérico"
                                  : ""
                              }
                              onChange={(e) => {
                                const value = e.target.value;
                                if (!isNaN(value) || value === "") {
                                  setPackages(value);
                                }
                              }}
                            />
                          </Grid>
                          <Grid item xs={12} sm={6} className="pd-r-10">
                            {originCountry === "CL" ? (
                              <InputMask
                                mask="99.999.999-9"
                                value={contactRut}
                                onChange={(e) => setContactRut(e.target.value)}
                                maskChar=""
                              >
                                {() => (
                                  <TextField
                                    fullWidth
                                    variant="outlined"
                                    label="RUT*"
                                    name="contactRut"

                                  />
                                )}
                              </InputMask>
                            ) : (
                              <TextField
                                fullWidth
                                value={contactRut}
                                onChange={(e) => setContactRut(e.target.value)}
                                variant="outlined"
                                label="RFC"
                                name="contactRut"
                              />
                            )}
                          </Grid>
                          <Grid item xs={12} sm={6} className="pd-l-10">
                            <InputMask
                              mask={phoneMask}
                              value={contactPhone}
                              onChange={(e) => setContactPhone(e.target.value)}
                              disabled={false}
                              maskChar=" "
                            >
                              {() => (
                                <TextField
                                  fullWidth
                                  error={submitPressed && contactPhone === ""}
                                  variant="outlined"
                                  label="Número de contacto*"
                                  name="contactPhone"
                                  helperText={
                                    submitPressed && contactPhone === ""
                                      ? "Campo obligatorio"
                                      : ""
                                  }
                                />
                              )}
                            </InputMask>
                          </Grid>
                          <Grid item xs={12} sm={6} className="pd-r-10">
                            <TextField
                              fullWidth
                              error={
                                (submitPressed && contactEmail === "") ||
                                (contactEmail !== "" &&
                                  !EmailValidator.validate(contactEmail))
                              }
                              variant="outlined"
                              label="Correo de contacto*"
                              name="contactEmail"
                              value={contactEmail}
                              onChange={(e) => setContactEmail(e.target.value)}
                              helperText={
                                submitPressed && contactEmail === ""
                                  ? "Campo obligatorio"
                                  : contactEmail !== "" &&
                                    !EmailValidator.validate(contactEmail)
                                    ? "Formato incorrecto"
                                    : ""
                              }
                            />
                          </Grid>
                          {selectedOrderType &&
                            selectedOrderType.value !== "delivery" &&
                            selectedOrderType.value !== "pick_up" &&
                            selectedOrderType.value !== "delivery_return" && (
                              <Grid item xs={12} sm={12}>
                                <ProductList
                                  setSelectedProductList={
                                    setSelectedProductList
                                  }
                                  selectedProductList={selectedProductList}
                                  productOptions={productOptions}
                                  productSaved={productSaved}
                                  orderType={selectedOrderType}
                                />
                              </Grid>
                            )}
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </>
              )}
            </Grid>
          </Grid>
          {selectedFileType === "Carga manual" && (
            <Grid
              container
              className="container-upload-files"
              style={{ marginTop: "15px" }}
            >
              <Grid item xs={12} className="flex-center">
                <Button
                  type="submit"
                  variant="contained"
                  onClick={handleSubmit}
                >
                  {loading ? (
                    <CircularProgress className="loading-btn" />
                  ) : (
                    "Cargar orden"
                  )}
                </Button>
              </Grid>
            </Grid>
          )}
          {/* Show excel drop if is admin has selected a warehouse (and a seller) or if is seller and has selected a warehouse */}
          {((isAdmin &&
            selectedSellerWarehouse &&
            selectedFileType === "Carga masiva") ||
            (isSeller &&
              selectedWarehouse &&
              selectedFileType === "Carga masiva")) && (
              <>
                <Grid item xs={12} className="flex-center">
                  <CustomDropzone
                    accept={".xlsx"}
                    width={"550px"}
                    marginTop={"50px"}
                    onDrop={handleFileDrop}
                  />
                </Grid>
                <Grid item xs={12} className="flex-center">
                  <Grid item className="custom-stack-container">
                    <Stack direction="row" spacing={1} className="custom-stack">
                      {files.map((file, index) => {
                        return (
                          <Chip
                            key={index}
                            label={file.path}
                            onDelete={() => handleDelete(file.path)}
                          />
                        );
                      })}
                    </Stack>
                  </Grid>
                </Grid>
                <Grid item xs={12} sm={12} className="flex-center">
                  {loading ? (
                    <CircularProgress className="loading-btn" />
                  ) : (
                    <Button
                      type="submit"
                      variant="contained"
                      onClick={handleFileSubmit}
                      disabled={!validFile || loading}
                    >
                      Cargar archivo
                    </Button>
                  )}
                </Grid>
              </>
            )}
          <AlertBox
            severity="success"
            messageAlert={messageAlert}
            setOpenAlert={setOpenSuccessAlert}
            openAlert={openSuccessAlert}
            hideDuration={6000}
          />
          <AlertBox
            severity="error"
            messageAlert={messageAlert}
            setOpenAlert={setOpenErrorAlert}
            openAlert={openErrorAlert}
            hideDuration={6000}
          />
          <AlertBox
            severity="error"
            messageAlert={messageAlert}
            setOpenAlert={setOpenFileErrorAlert}
            openAlert={openFileErrorAlert}
            hideDuration={6000}
          />
        </>
      )}
    </>
  );
}

export default NewUploadRequests;
